// extracted by css-extract-rspack-plugin
export default {"idle":"Idle-module__idle__p5XiF","copilotRun":"Idle-module__copilotRun__IF2Wt"};